import React, { Fragment } from "react";

import Icon from "core/ui-kit/icon";

import { useTranslation } from "core/hooks/useTranslation";

const Empty = () => {
    const { t } = useTranslation();

    return (
        <div className="rt--commissions-empty rt--flex rt--align-center rt--justify-center">
            <div className="rt--commissions-empty-inner rt--flex rt--flex-col rt--align-center rt--justify-center">
                <div className="rt--flex rt--align-center rt--justify-center rt--pt-20 rt--pb-20">
                    <Icon name="not-found" size={120} />
                </div>
                <Fragment>
                    <b className="rt--font-regular rt--font-normal rt--pb-4">{t("backoffice.commissionplans.noCommissionsAssignedYet")}</b>
                    <span className="rt--font-regular rt--font-normal">{t("backoffice.commissionplans.noCommissionsAssignedYetInfo")}</span>
                </Fragment>
            </div>
        </div>
    )
}

export default Empty;